import Vue from 'vue'
import axios from 'axios'
// import vm from '../main'

const request = axios.create({
  baseURL: process.env.BASE_API || '', // api 的 base_url
  timeout: 5000 // request timeout
})

request.interceptors.request.use(
  config => {
    // Do something before request is sent

      // 让每个请求携带token-- ['X-Token']为自定义key 请根据实际情况自行修改
      config.headers['content-type'] = 'application/json;charset=UTF-8'
    return config
  },
  error => {
    // Do something with request error
    console.log(error) // for debug
    Promise.reject(error)
  }
)

Vue.prototype.request = request

export default request


// WEBPACK FOOTER //
// ./src/utils/axios.js